// src/theme/tokens/colors.js

export const colors = {
  brand: {
    primary: '#2C4B39',    // Dunkelgrün - Hauptfarbe
    secondary: '#D4E0C9',  // Hellgrün - Sekundärfarbe
    accent: '#1F3A2D'      // Akzentgrün - für Hervorhebungen
  },
  
  text: {
    light: '#D4E0C9',      // Heller Text auf dunklem Hintergrund
    dark: '#2C4B39',       // Dunkler Text auf hellem Hintergrund
    muted: 'rgba(0, 0, 0, 0.45)', // Abgeschwächter Text
    disabled: 'rgba(0, 0, 0, 0.25)', // Deaktivierter Text
    inverse: '#ffffff'     // Weißer Text
  },
  
  background: {
    primary: '#2C4B39',    // Haupthintergrund
    secondary: '#D4E0C9',  // Sekundärer Hintergrund
    light: '#ffffff',      // Heller Hintergrund
    dark: '#1F3A2D',       // Dunkler Hintergrund
    overlay: 'rgba(0, 0, 0, 0.45)' // Für Overlays/Modals
  },
  
  status: {
    success: '#52c41a',
    warning: '#faad14',
    error: '#ff4d4f',
    info: '#1890ff'
  },
  
  border: {
    light: '#f0f0f0',
    main: '#d9d9d9',
    dark: '#595959'
  },
  
  // Spezielle Farben für Tabellen
  table: {
    header: '#1F3A2D',
    rowEven: 'transparent',
    rowOdd: 'rgba(255, 255, 255, 0.05)',
    border: '#D4E0C9'
  }
};
